import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames/bind';
import { CopyableOverlayTrigger } from 'components/CopyableOverlayTrigger/CopyableOverlayTrigger';
import React from 'react';
import styles from './status.module.scss';

const classNames = cx.bind(styles);

export const getEffectiveStatusDefaultColor = (effectiveStatus) => {
  const colorMap = {
    preapproved: 'success',
    pending_review: 'warning',
    pending_billing_info: 'warning',
    paused: 'black',
    campaign_paused: 'black',
    adset_paused: 'black',
    deactive: 'black',
    in_process: 'whiteTheme4',
    disapproved: 'danger',
    archived: 'danger',
    with_issues: 'danger',
    budget_remain: 'danger',
    deleted: 'danger'
  };

  const key = effectiveStatus.toLowerCase();
  return colorMap[key] ? colorMap[key] : 'theme1';
};

export const Status: React.FC<{
  color: string;
  label: string;
  icon?: IconDefinition;
  renderExtraInfo?: () => React.ReactNode;
}> = ({ color, label, icon, renderExtraInfo }) => {
  return (
    <>
      <CopyableOverlayTrigger
        placement='bottom'
        overlay={renderExtraInfo ? renderExtraInfo() : undefined}
      >
        <div
          className={classNames('status', styles[color], {
            pointer: !!renderExtraInfo
          })}
        >
          {icon && <FontAwesomeIcon className={styles.icon} icon={icon} />}
          {label}
        </div>
      </CopyableOverlayTrigger>
    </>
  );
};
